import React from 'react';
import { useEffect } from 'react';
import {
  Typography,
  Link,
  Grid,
  CircularProgress,
  Button,
} from '@mui/material';
import PageTitle from '../../common/components/PageTitle';
import { useSelector } from 'react-redux';
import { selectUserFirstName } from '../../common/auth/UserSlice';
import {
  selectLINKtivityAccessAllowed,
  selectSubscriptionLoaded,
} from '../../common/subscription/SubscriptionSlice';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  EXT_TUTORIALS,
  SUBSCRIPTION,
  LTVLIBNEWANDFEATURED,
} from '../../routes/CONSTANTS';
import Categories from '../linktivityLibrary/Categories';
import NewAndFeaturedList from '../linktivityLibrary/NewAndFeaturedList';

export function AuthHome() {
  const firstName = useSelector(selectUserFirstName);
  const LINKtivityAccessAllowed = useSelector(selectLINKtivityAccessAllowed);
  const subscriptionDetailsLoaded = useSelector(selectSubscriptionLoaded);
  const navigate = useNavigate();

  const handleViewAllNewFeaturedClick = (event) => {
    event.preventDefault();
    navigate(LTVLIBNEWANDFEATURED);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageTitle title={'Member Home - Welcome, ' + firstName + '!'} />
      {subscriptionDetailsLoaded !== true ? (
        <>
          <Grid container spacing={10}>
            <Grid item xs={12}>
              <CircularProgress color='secondary' />
            </Grid>
          </Grid>
        </>
      ) : LINKtivityAccessAllowed ? (
        <>
          <Typography variant='h5' textAlign={'left'}>
            We're glad you're here. With your LINKtivity® membership, you can
            tap into a library full of LINKtivities that teach a variety of
            standards-based topics, skills, and strategies. Let's get started!
          </Typography>
          <Typography
            sx={{ fontWeight: 'bold', paddingTop: 2 }}
            textAlign={'left'}
          >
            New to LINKtivity Learning?
          </Typography>
          <Typography textAlign={'left'}>
            Head over to the{' '}
            <Link href={EXT_TUTORIALS} target='_blank' rel='noreferrer'>
              video tutorial library
            </Link>{' '}
            to take a tour of the membership site and get tips for getting the
            most out of your membership.
          </Typography>
          <Typography
            sx={{ fontWeight: 'bold', paddingTop: 2 }}
            textAlign={'left'}
          >
            Ready to dive in?
          </Typography>
          <Typography textAlign={'left'}>
            Check out the new and featured LINKtivities or choose a category to
            start exploring!
          </Typography>
        </>
      ) : (
        <>
          <Typography variant='h5' textAlign={'left'}>
            We're glad you're here.{' '}
            <b>
              You don't currently have access to the LINKtivity® Library because
              your subscription is not active
            </b>{' '}
            (it may be paused or expired). You can manage your subscription
            settings{' '}
            <Link component={RouterLink} to={SUBSCRIPTION}>
              here
            </Link>{' '}
            to gain access right away!
          </Typography>
          <Typography
            sx={{ fontWeight: 'bold', paddingTop: 2 }}
            textAlign={'left'}
          >
            Library Preview
          </Typography>
          <Typography textAlign={'left'}>
            While your subscription is inactive, you can still preview the
            LINKtivity Library. Start by checking out the new and featured
            LINKtivities or choose a category below!
          </Typography>
        </>
      )}
      <Typography variant='h4' style={{ marginTop: '50px' }}>
        New and Featured LINKtivities
      </Typography>
      <NewAndFeaturedList numItems={3} />
      <Button
        variant='contained'
        onClick={handleViewAllNewFeaturedClick}
        style={{ margin: '30px' }}
        size='large'
      >
        See All New & Featured
      </Button>
      <Typography variant='h4' style={{ marginTop: '50px' }}>
        All LINKtivities by Category
      </Typography>
      <Categories />
    </>
  );
}
